import { render, staticRenderFns } from "./RegistrationsCard.vue?vue&type=template&id=30b54af5&"
import script from "./RegistrationsCard.vue?vue&type=script&lang=js&"
export * from "./RegistrationsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports